import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useTranslation from 'hooks/useTranslations'

import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

import NoNotifications from 'ui/modules/emptyState/noNotifications'
import Notification from 'ui/modules/notifications'
import SimplePopover from 'ui/modules/popover'

import { getNotifications } from 'services/notifications/selectors'
import {
  setNotificationsCount,
  removeNotification,
  markNotification,
  clearNotifications,
  fakeReactAllNotifications,
} from 'services/notifications/actions'
import { formatNotifications } from 'services/notifications/business'
import * as actionTypesNotifications from 'services/notifications/action-types'
import { loadLocale } from 'services/locale'
import { showSnackbar } from 'services/snackbar/actions'

const EMPTY_NOTIFICATIONS = { today: [], next: [] }

const Notifications = ({ anchorEl, onClose }) => {
  const t = useTranslation()
  const dispatch = useDispatch()

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined
  const allNotifications = useSelector(getNotifications)

  const locale = loadLocale() || 'es'
  const [notifications, setNotifications] = useState(EMPTY_NOTIFICATIONS)

  useEffect(() => {
    const formatedNotifications = formatNotifications(allNotifications, locale)
    setNotifications(formatedNotifications)
  }, [allNotifications, locale])

  const handleRemoveAll = useCallback(() => {
    dispatch(setNotificationsCount(0))
    dispatch(clearNotifications())
    dispatch(
      showSnackbar({
        message: 'notifications:remove-all-confirm',
        actionToDo: {
          type: actionTypesNotifications.REMOVE_ALL,
        },
        actionOnCancel: {
          type: actionTypesNotifications.FETCH,
        },
      }),
    )

    setNotifications(EMPTY_NOTIFICATIONS)
  }, [dispatch])

  const handleReadAll = useCallback(() => {
    dispatch(fakeReactAllNotifications())
    dispatch(setNotificationsCount(0))

    dispatch(
      showSnackbar({
        message: 'notifications:all-readed-confirm',
        actionToDo: {
          type: actionTypesNotifications.READ_ALL,
        },
        actionOnCancel: {
          type: actionTypesNotifications.FETCH,
        },
      }),
    )
  }, [dispatch])

  const handleRemove = useCallback(
    id => {
      dispatch(removeNotification(id))
    },
    [dispatch],
  )

  const handleMark = useCallback(
    (id, viewed) => {
      dispatch(markNotification(id, viewed))
    },
    [dispatch],
  )

  return (
    <SimplePopover
      anchorEl={anchorEl}
      title={t('notifications:title')}
      id={id}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      actions={
        notifications.today.length && notifications.next.length ? (
          <>
            <Button onClick={handleReadAll} color="primary">
              {t('notifications:all-readed-action')}
            </Button>
            <Button onClick={handleRemoveAll} color="primary">
              {t('notifications:remove-all-action')}
            </Button>
          </>
        ) : null
      }
    >
      {notifications.today.length || notifications.next.length ? (
        <Box>
          <Box display="flex" pb={1} pl={4} pr={3}>
            <Typography variant="overline">
              {t('notifications:today')}
            </Typography>
          </Box>
          {notifications.today.map(notification => (
            <Notification
              key={notification.id}
              id={notification.id}
              messageType={notification.type}
              tag={t('notifications:vendor')}
              title={notification.title}
              text={notification.message}
              time={t('time-ago', { time: notification.timeAgo })}
              onClick={handleRemove}
              onChange={handleMark}
              isChecked={!notification.viewed}
              radioValue={notification.id}
              vendorId={notification._resource.id}
            />
          ))}
          <Box display="flex" pt={2} pb={1} pl={4} pr={3}>
            <Typography variant="overline">
              {t('notifications:previous')}
            </Typography>
          </Box>
          {notifications.next.map(notification => (
            <Notification
              key={notification.id}
              id={notification.id}
              messageType={notification.type}
              tag="Proveedor"
              title={notification.title}
              text={notification.message}
              time={t('time-ago', { time: notification.timeAgo })}
              onClick={handleRemove}
              onChange={handleMark}
              isChecked={!notification.viewed}
              radioValue={notification.id}
              vendorId={notification._resource.id}
            />
          ))}
        </Box>
      ) : (
        <Box display="flex" justifyContent="center">
          <NoNotifications />
        </Box>
      )}
    </SimplePopover>
  )
}

export default Notifications
